import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import { Spacing, SpacingTokenType } from '@common/tokens';

type DirectionType =
  | 'all'
  | 'vertical'
  | 'horizontal'
  | 'top'
  | 'bottom'
  | 'left'
  | 'right';

export const Gutter = ({
  size = 'sm',
  inlineBlock = false,
  asPadding = false,
  direction = 'all',
  fullWidth = false,
  className,
  children,
}: PropsWithChildren<{
  size?: SpacingTokenType;
  /** When true, uses `display: inline-block` so the box shrinks to content width (formerly `fit`). */
  inlineBlock?: boolean;
  /** When true, applies spacing as padding; when false (default), as margin (formerly `internal`). */
  asPadding?: boolean;
  direction?: DirectionType;
  fullWidth?: boolean;
  className?: string;
}>) => {
  const numericSize = Spacing[size];
  const gutterKind = asPadding ? 'padding' : 'margin';
  const style = buildStyle(gutterKind, direction, numericSize);

  return (
    <div
      className={clsx('wk-gutter', className)}
      style={{
        display: inlineBlock ? 'inline-block' : 'block',
        width: fullWidth ? '100%' : undefined,
        ...style,
      }}
    >
      {children}
    </div>
  );
};

function buildStyle(
  gutterKind: 'padding' | 'margin',
  direction: DirectionType,
  numericSize: number
) {
  if (direction === 'vertical') {
    return {
      [`${gutterKind}Top`]: numericSize,
      [`${gutterKind}Bottom`]: numericSize,
    };
  }

  if (direction === 'horizontal') {
    return {
      [`${gutterKind}Left`]: numericSize,
      [`${gutterKind}Right`]: numericSize,
    };
  }

  if (direction === 'top') {
    return {
      [`${gutterKind}Top`]: numericSize,
    };
  }

  if (direction === 'bottom') {
    return {
      [`${gutterKind}Bottom`]: numericSize,
    };
  }

  if (direction === 'left') {
    return {
      [`${gutterKind}Left`]: numericSize,
    };
  }

  if (direction === 'right') {
    return {
      [`${gutterKind}Right`]: numericSize,
    };
  }

  return {
    [gutterKind]: numericSize,
  };
}
